import React from 'react';
import './FEPricing.css';

export const plans = [
    {
        name: 'Emprendedor',
        price: '990',
        highlighted: false,
        badge: null,
        features: [
            'Hasta 125 e-CF por mes',
            '1 usuario',
            'Certificación como emisor',
            'Reportes 606, 607 y 608',
            'Soporte por correo',
        ],
        cta: 'Solicitar demo',
    },
    {
        name: 'PYME',
        price: '1,990',
        highlighted: true,
        badge: 'Más popular',
        features: [
            'Hasta 500 e-CF por mes',
            'Hasta 5 usuarios',
            'Certificación como emisor',
            'Reportes 606, 607 y 608',
            'Conciliación bancaria',
            'Soporte prioritario WhatsApp',
        ],
        cta: 'Solicitar demo',
    },
    {
        name: 'Empresarial',
        price: '2,990',
        highlighted: false,
        badge: null,
        features: [
            'Todo en PYME',
            'Usuarios ilimitados',
            'Hasta 1,500 e-CF por mes',
            'POS punto de venta integrado',
            'CRM de clientes',
            'Multi-sucursal',
            'Crédito fiscal por adopción temprana',
        ],
        cta: 'Solicitar demo',
    },
];

const FEPricing = () => {
    return (
        <section id="fe-pricing" className="fe-pricing">
            <div className="container">
                <div className="row justify-content-center mb-5">
                    <div className="col-lg-7 text-center">
                        <span className="fe-pricing__label">Precios</span>
                        <h2 className="fe-pricing__heading">Planes de facturación electrónica</h2>
                        <p className="fe-pricing__subheading">
                            Todos los planes incluyen emisión de e-CF ilimitados y certificado de firma digital.
                            Las empresas que implementen antes del plazo pueden acceder a un crédito fiscal por adopción temprana.
                        </p>
                    </div>
                </div>

                <div className="row justify-content-center align-items-stretch">
                    {plans.map((plan, index) => (
                        <div
                            key={index}
                            className={`col-lg-4 col-md-6 mb-4 mb-lg-0 d-flex${plan.highlighted ? ' fe-pricing__col--featured' : ''}`}
                        >
                            <div
                                className={`fe-pricing-card w-100${plan.highlighted ? ' fe-pricing-card--featured' : ''}`}
                            >
                                {plan.badge && (
                                    <div className="fe-pricing-card__badge">{plan.badge}</div>
                                )}

                                <div
                                    className={`fe-pricing-card__header${plan.highlighted ? ' fe-pricing-card__header--featured' : ''}`}
                                >
                                    <h3 className="fe-pricing-card__name">{plan.name}</h3>
                                    <div className="fe-pricing-card__price-wrap">
                                        <span className="fe-pricing-card__currency">RD$</span>
                                        <span className="fe-pricing-card__price">{plan.price}</span>
                                        <span className="fe-pricing-card__period">/mes</span>
                                    </div>
                                </div>

                                <div className="fe-pricing-card__body">
                                    <ul className="fe-pricing-card__features">
                                        {plan.features.map((feature, i) => (
                                            <li key={i} className="fe-pricing-card__feature">
                                                <i className="fas fa-check fe-pricing-card__check"></i>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>

                                    <a
                                        href="#fe-hero"
                                        className={`btn w-100 fe-pricing-card__cta${plan.highlighted ? ' btn-fe-primary' : ' btn-fe-outline'}`}
                                    >
                                        {plan.cta}
                                    </a>

                                    <p className="fe-pricing-card__note">
                                        <i className="fas fa-lock mr-1"></i>
                                        Solicitar demo sin compromiso
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="row mt-4">
                    <div className="col-12 text-center">
                        <p className="fe-pricing__footer-note">
                            <i className="fas fa-phone-alt fe-accent-text mr-2"></i>
                            ¿Necesitas un plan personalizado?{' '}
                            <a
                                href="https://wa.me/18096050699"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="fe-accent-text font-weight-bold"
                            >
                                Contáctanos por WhatsApp
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FEPricing;
